import { StorageUtilities, StorageKeys } from '@dealstack/frontend/shared/helper/storageUtils';

export const getTokenLockTime = (): number | null => {
	const lockTime = StorageUtilities.getItem(StorageKeys.TOKEN_LOCK_TIME_IN_Millis);
	if (!lockTime) {
		return null;
	}

	return parseInt(lockTime, 10);
};
